import { WidgetResponse } from '../../../sharedModules/api/searchApi/createWidgetResponseGetter';
import getWidget from '../../../utils/getWidget';
import type { Tab } from '../../types/Tab';

import { getWidgetTypeComponent } from './getWidgetTypeComponent';
import setupTabs from './setupTabs';
import type { ModelWidgetData } from './types';

export const isWidgetMissing = (defaultTab: Tab | null, tabConfigs: Tab[]): boolean => {
  return !((defaultTab?.value || defaultTab?.type) && tabConfigs.length > 0);
};

const EMPTY_WIDGET_RESPONSE: WidgetResponse = {
  widget: {
    data: {
      counts: {
        broadband: 0,
        subscriptions: 0,
        contracts: 0,
        deals: 0,
        accessories: 0,
        fallback: 0,
        offers: 0,
        vouchers: 0,
        unique_codes: 0,
        offer_deals: 0,
        newsletter: 0,
        similar: 0,
        multimedia: 0,
        rewards: 0,
      },
      offers: [],
      offer_type: '',
      filters: [],
      offer_types: [],
      pagination: {
        limit: 0,
        limit_contracts: 0,
        limit_deals: 0,
        offset: null,
      },
      event: null,
      title: '',
      last_update: null,
      sponsor: null,
    },
  },
  battle: null,
  area: null,
  models: {},
  version: '',
};

export const updateWidgetConfig = (setupModelWidgetData: ModelWidgetData): ModelWidgetData => {
  const { options, model } = setupModelWidgetData;
  const { features, localiser, props } = options;
  const { params, widget } = props;
  const { widgetResponse } = model;
  const {
    models,
    area,
    widget: { data },
  } = widgetResponse?.ok ? widgetResponse.data : EMPTY_WIDGET_RESPONSE;

  const { tabConfigs, defaultTab } = setupTabs({
    data,
    params,
    features,
    widget,
    localiser,
    models,
    area,
  });

  const widgetType = getWidgetTypeComponent(props, defaultTab);
  const widgetChanged = widget.type !== widgetType;

  return {
    options: {
      ...options,
      props: {
        ...props,
        widgetType,
        widget: getWidget(widgetType),
      },
    },
    model: {
      ...model,
      widgetChanged,
      defaultTab,
      tabConfigs,
      widgetMissing: isWidgetMissing(defaultTab, tabConfigs),
    },
  };
};
